import { BarChart3, TrendingUp, Activity, PieChart } from "lucide-react";
import heroImage from "@/assets/hero-person-analytics.png";
import ProductHeroI18n from "../shared/ProductHeroI18n";

const AnalyticsHero = () => {
  return (
    <ProductHeroI18n
      translationPrefix="analyticsPage"
      heroImage={heroImage}
      imageAlt="Chathero AI Analytics"
      floatingIcons={[
        { icon: BarChart3, color: "mint" },
        { icon: TrendingUp, color: "orange" },
        { icon: Activity, color: "primary" },
        { icon: PieChart, color: "mint" },
      ]}
    />
  );
};

export default AnalyticsHero;
